import { createFileRoute } from '@tanstack/react-router';

import { ClientSessionDetailScreen } from '@/features/sessions/components/client/ClientSessionDetailScreen';

export const Route = createFileRoute('/client/sessions/$sessionId')({
  component: ClientSessionDetailRoute,
});

function ClientSessionDetailRoute() {
  const { sessionId } = Route.useParams();
  return <ClientSessionDetailScreen sessionId={sessionId} />;
}
